// 模特历史记录服务
import axios from 'axios';
import { getConfig } from './api';

// 获取API基础URL
const getApiBaseUrl = () => {
  return getConfig().apiBaseUrl || 'https://warehouseapi.proxypool.eu.org';
};

// 获取存储的认证令牌
const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token');
  const headers = {};
  
  if (token) {
    headers['X-Auth-Token'] = token;
  }
  
  return headers;
};

// 获取模特历史记录列表
export const getModelHistory = async () => {
  try {
    const response = await axios.get(`${getApiBaseUrl()}/api/model-history/list`, {
      headers: getAuthHeaders()
    });
    
    return response.data;
  } catch (error) {
    console.error('获取模特历史记录失败:', error);
    throw error;
  }
};

// 保存模特历史记录
export const saveModelHistory = async (modelData) => {
  try {
    const { url, prompt, metadata } = modelData;
    
    const response = await axios.post(`${getApiBaseUrl()}/api/model-history/save`, {
      url,
      prompt,
      metadata
    }, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('保存模特历史记录失败:', error);
    throw error;
  }
};

// 删除模特历史记录
export const deleteModelHistory = async (id) => {
  try {
    const response = await axios.post(`${getApiBaseUrl()}/api/model-history/delete`, {
      id
    }, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('删除模特历史记录失败:', error);
    throw error;
  }
};
